import axios from 'axios'


axios.defaults.baseURL = process.env.APP_ENV === 'localhost' ? process.env.API_URL_LOCALHOST : process.env.API_URL
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(localStorage.getItem('tbStore.jwt'))
axios.defaults.headers.common['Set-Cookie: cross-site-cookie=whatever; SameSite=None; Secure']
// axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');